import type { Ticket, TicketState } from '../../domain/types';
import { ticketCard } from './home-view';

const filters = ['全部', '待回应', '进行中', '待确认', '已归档'] as const;
type TicketFilter = typeof filters[number];

export function renderTicketList(container: HTMLElement, tickets: Ticket[]): void {
  container.replaceChildren();
  const section = document.createElement('section');
  section.className = 'ticket-list-view stack';
  section.innerHTML = `
    <div class="section-heading"><h1>单据</h1><a class="button button--compact" href="#create/reward">新建</a></div>
    <label class="field search-field">搜索单据<input type="search" placeholder="标题、内容或标签" data-ticket-search></label>
    <div class="filter-row" role="group" aria-label="筛选单据"></div>
    <div class="ticket-cards" data-ticket-results></div>
  `;
  const filterRow = section.querySelector<HTMLElement>('.filter-row')!;
  const results = section.querySelector<HTMLElement>('[data-ticket-results]')!;
  const search = section.querySelector<HTMLInputElement>('[data-ticket-search]')!;
  let selected: TicketFilter = '全部';

  const refresh = (): void => {
    const query = search.value.trim().toLocaleLowerCase('zh-CN');
    const visible = [...tickets]
      .sort((left, right) => right.updatedAt.localeCompare(left.updatedAt))
      .filter((ticket) => filterState(selected, ticket.state))
      .filter((ticket) => searchableText(ticket).includes(query));
    results.replaceChildren();
    if (visible.length === 0) {
      const empty = document.createElement('p');
      empty.className = 'empty-state';
      empty.textContent = '没有符合条件的单据。';
      results.append(empty);
    } else {
      for (const ticket of visible) results.append(ticketCard(ticket));
    }
  };

  for (const filter of filters) {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'filter-chip';
    button.textContent = filter;
    button.setAttribute('aria-pressed', String(filter === selected));
    button.addEventListener('click', () => {
      selected = filter;
      for (const candidate of filterRow.querySelectorAll('button')) {
        candidate.setAttribute('aria-pressed', String(candidate === button));
      }
      refresh();
    });
    filterRow.append(button);
  }
  search.addEventListener('input', refresh);
  refresh();
  container.append(section);
}

function filterState(filter: TicketFilter, state: TicketState): boolean {
  if (filter === '全部') return true;
  if (filter === '待回应') return state === 'pending_response';
  if (filter === '进行中') return state === 'accepted';
  if (filter === '待确认') return state === 'pending_confirmation';
  return state === 'completed';
}

function searchableText(ticket: Ticket): string {
  return [ticket.title, ticket.description, ticket.outcome, ticket.signature, ...ticket.tags]
    .join('\n')
    .toLocaleLowerCase('zh-CN');
}
